import { Button } from '@/components/ui/button';
import { VoyagerDropdown } from '@/components/ui/voyager-dropdown';
import { User } from 'lucide-react';

interface VoyagerButtonProps {
  variant?: "default" | "outline" | "ghost" | "secondary" | "destructive";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}

export function VoyagerButton({ 
  variant = "outline", 
  size = "default",
  className 
}: VoyagerButtonProps) {
  return (
    <VoyagerDropdown>
      <Button 
        variant={variant} 
        size={size}
        className={className}
      >
        <User className="h-4 w-4 md:h-5 md:w-5" />
      </Button>
    </VoyagerDropdown>
  );
}